<template>
	<div class="login_box">
		<div class="login_user_box">
			<img class="login_title_box" src="../../assets/images/bg/login_title.png" alt="">
			<el-form class="user_form" ref="ruleForm" :model="userInfo" :rules="rules" @keyup.enter.native="submitForm('ruleForm')">
				<el-form-item prop="userName">
					<el-input v-model="userInfo.userName" placeholder="用户名">
						<img slot="prefix" class="el-input__icon" src="../../assets/images/bg/login_icon_user.png" alt="icon">
					</el-input>
				</el-form-item>
				<el-form-item prop="password" v-if="eyeStatus">
					<el-input type="password" v-model="userInfo.password" placeholder="密码">
						<img slot="prefix" class="el-input__icon" src="../../assets/images/bg/login_icon_password.png" alt="icon">
						<img slot="suffix" class="el-input__icon head" src="../../assets/images/bg/login_icon_visible.png" alt="icon" @click.stop="onEye">
					</el-input>
				</el-form-item>
				<el-form-item prop="password" v-else>
					<el-input type="text" v-model="userInfo.password" placeholder="密码">
						<img slot="prefix" class="el-input__icon" src="../../assets/images/bg/login_icon_password.png" alt="icon">
						<img slot="suffix" class="el-input__icon head" src="../../assets/images/bg/login_icon_invisible.png" alt="icon" @click.stop="onEye">
					</el-input>
				</el-form-item>
				<el-form-item prop="verCode">
					<span class="login_flex">
						<el-input style="width: 60%;" v-model="userInfo.verCode" placeholder="验证码">
							<img slot="prefix" class="el-input__icon" src="../../assets/images/bg/login_icon_code.png" alt="icon">
						</el-input>
						<img class="verCodeImg head" :src="imgSrc" alt="" @click="getVerifyCode">
					</span>
				</el-form-item>
				<!-- <el-form-item style="text-align: left;">
					<el-checkbox-group v-model="rememberPassword">
						<el-checkbox label="记住密码" name="rememberPassword"></el-checkbox>
					</el-checkbox-group>
				</el-form-item> -->
				<el-form-item>
					<el-button style="width: 100%;" type="primary" :loading="loading" @click="submitForm('ruleForm')">登录</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import CryptoJS from 'crypto-js'

	export default {
		data () {
			return {
				secretKey: "14508ec3a4b0d3b9f90fce09f137f91442bd7dc8241d9129001331abb721aaa0",
				userInfo: {
					userName: "",
					password: "",
					verCode: "",
					verTime: "",
				},
				rules: {
					userName: [
						{ required: true, message: '请输入用户名', trigger: 'blur' }
					],
					password: [
						{ required: true, message: '请输入密码', trigger: 'blur' }
					],
					verCode: [
						{ required: true, message: '请输入验证码', trigger: 'blur' }
					],
				},
				eyeStatus: true,
				imgSrc: "",
				rememberPassword: false,
				loading: false,

			}
		},
		mounted () {
			this.getVerifyCode();
			// this.fetchAdminUserInfo();
			let userInfo = localStorage.getItem("userInfo");
			if (userInfo) {
				let { username, password } = JSON.parse(userInfo);
				this.rememberPassword = true;
				let name = this.decryptData(username, this.secretKey);
				this.userInfo.userName = name ? name : username;
				let text = this.decryptData(password, this.secretKey);
				this.userInfo.password = text ? text : password; 
			}
			// this.generateKey();
		},
		methods: {
			generateKey() { // 生成一个随机的AES密钥（256位）
				const key = CryptoJS.lib.WordArray.random(256/8); // 256位密钥长度，单位为字节
				let secretKey = key.toString(CryptoJS.enc.Hex); // 将密钥转换为十六进制字符串形式
				console.log('Generated Key:', secretKey); // 在控制台输出密钥，方便调试
				return secretKey;
			},
			encryptData(password, secretKey) { //加密
				return CryptoJS.AES.encrypt(password, secretKey).toString();
			},
			decryptData(ciphertext, secretKey) { //解码
				return CryptoJS.AES.decrypt(ciphertext, secretKey).toString(CryptoJS.enc.Utf8);
			},

			fetchAdminUserInfo () {//获取用户信息
				return new Promise((resolve, reject) => {
					this.$axios.get('/rm-user-manage/api/admin/user/adminUserInfo').then(res => {
						let data = this.AppUtils.checkResponse(res);
						if (data) {
							console.log(data)
							resolve(data);
						}
					})
				},
				)
			},

			submitForm (formName) {
				let _this = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.onLogin();
					} else {
						return false;
					}
				})
			},

			// 登录
			onLogin () {
				var _this = this;
				this.loading = true;
				let params = JSON.parse(JSON.stringify(this.userInfo));
				params.userName = this.encryptData(params.userName, this.secretKey);
				params.password = this.encryptData(params.password, this.secretKey);
				// console.log(params)
				// console.log(this.decryptData(params.userName, this.secretKey))
				// console.log(this.decryptData(params.password, this.secretKey))
				// return
				this.$axios.post('/rm-user-manage/api/admin/user/login', params).then(res => {
					this.initUser();
					let data = this.AppUtils.checkResponse(res);
					if (data) {
						// if (this.rememberPassword) { //记住密码
							localStorage.setItem("userInfo", JSON.stringify({
								username: params.userName,
								password: params.password
							}))
						// } else {
						// 	localStorage.setItem("userInfo", "")
						// }
						console.log(data)
						if (data.data.token) {
							localStorage.setItem('token', data.data.token);
							this.AppUtils.setCookie("token", data.data.token);
							this.$store.commit("TOKEN_INIT", {
								token: data.data.token
							})
							this.fetchAdminUserInfo().then(data => {
								localStorage.setItem('authInfo', JSON.stringify(data.data));
								this.$store.commit('AUTH_INIT', data.data);
								if (data.data.authInfo) {
									this.$store.commit('USER_AUTH', data.data.authInfo);
								}
								var homeType
								if (data.data.projectId == 2) {
									homeType = "/home"
									let path = _this.$route.query.returnUrl || homeType;
									_this.$router.push(path);
									_this.$store.dispatch('fetchProjectList');
								} else {
									let path = '/4s/home';
									_this.$router.push(path);
								}
							})
						} else {
							_this.$router.push({
								path: '/changePassword',
								query: {
									key: data.data.key
								}
							})
						}
					} else {
						this.userInfo.verCode = null;
						this.getVerifyCode();
					}
				}).catch((err) => {
					// console.log(err)
				}).finally(() => {
					this.loading = false;
				})
			},

			onEye () {
				this.eyeStatus = !this.eyeStatus;
			},

			getVerifyCode () {
				var time = Math.random();
				this.userInfo.verTime = time;
				this.imgSrc = this.CODE_SERVER + '/rm-user-manage/api/admin/user/getVerifyCode?t=' + time;
			},

			initUser () {
				const usersArray = ['wuxiceshi', 'zhuweiming']
				const wfArray = ['weifang123', 'weifang1', 'weifang12']
				const tzArray = ['taizhouceshi', 'taizhou1', 'taizhou2', 'taizhou3']
				const cqArray = ['chongqing1', 'chongqing2', 'chongqingdiaodu','wangyanyingdiaodu', 'litingdiaodu', 'daihaojiediaodu', 'tianrongdiaodu' ]
				const szArray = ['zsbenz-shenzhen']
				const xmArray = ['zhanghuifang', 'lanyongfeng', 'wangke1', 'dingwenqing1', 'huangweiying1', 'wangfu1']
				const tjArray = ['diaoduwuyue', 'diaoduliyu']
				const nbArray = ['duizhang', 'weixiudan']
				if (usersArray.indexOf(this.userInfo.userName) > -1) {
					localStorage.removeItem('wfArray')
					localStorage.removeItem('tzArray')
					localStorage.removeItem('cqArray')
					localStorage.removeItem('szArray')
					localStorage.removeItem('tjArray')
					localStorage.removeItem('xmArray')
					localStorage.removeItem('nbArray')
					localStorage.setItem('usersArray', JSON.stringify(usersArray))
				} else if (wfArray.indexOf(this.userInfo.userName) > -1) {
					localStorage.removeItem('usersArray')
					localStorage.removeItem('tzArray')
					localStorage.removeItem('cqArray')
					localStorage.removeItem('szArray')
					localStorage.removeItem('tjArray')
					localStorage.removeItem('xmArray')
					localStorage.removeItem('nbArray')
					localStorage.setItem('wfArray', JSON.stringify(wfArray))
				} else if (tzArray.indexOf(this.userInfo.userName) > -1) {
					localStorage.removeItem('wfArray')
					localStorage.removeItem('usersArray')
					localStorage.removeItem('cqArray')
					localStorage.removeItem('szArray')
					localStorage.removeItem('xmArray')
					localStorage.removeItem('tjArray')
					localStorage.removeItem('nbArray')
					localStorage.setItem('tzArray', JSON.stringify(tzArray))
				} else if (cqArray.indexOf(this.userInfo.userName) > -1) {
					localStorage.removeItem('wfArray')
					localStorage.removeItem('usersArray')
					localStorage.removeItem('tzArray')
					localStorage.removeItem('szArray')
					localStorage.removeItem('xmArray')
					localStorage.removeItem('tjArray')
					localStorage.removeItem('nbArray')
					localStorage.setItem('cqArray', JSON.stringify(cqArray))
				} else if (szArray.indexOf(this.userInfo.userName) > -1) {
					localStorage.removeItem('wfArray')
					localStorage.removeItem('usersArray')
					localStorage.removeItem('tzArray')
					localStorage.removeItem('cqArray')
					localStorage.removeItem('xmArray')
					localStorage.removeItem('tjArray')
					localStorage.removeItem('nbArray')
					localStorage.setItem('szArray', JSON.stringify(szArray))
				} else if(xmArray.indexOf(this.userInfo.userName) > -1) {
					localStorage.removeItem('usersArray')
					localStorage.removeItem('wfArray')
					localStorage.removeItem('tzArray')
					localStorage.removeItem('cqArray')
					localStorage.removeItem('szArray')
					localStorage.removeItem('tjArray')
					localStorage.removeItem('nbArray')
					localStorage.setItem('xmArray', JSON.stringify(xmArray))
				} else if(tjArray.indexOf(this.userInfo.userName) > -1) {
					localStorage.removeItem('usersArray')
					localStorage.removeItem('wfArray')
					localStorage.removeItem('tzArray')
					localStorage.removeItem('cqArray')
					localStorage.removeItem('szArray')
					localStorage.removeItem('xmArray')
					localStorage.removeItem('nbArray')
					localStorage.setItem('tjArray', JSON.stringify(tjArray))
				} else if(nbArray.indexOf(this.userInfo.userName) > -1) {
					localStorage.removeItem('usersArray')
					localStorage.removeItem('wfArray')
					localStorage.removeItem('tzArray')
					localStorage.removeItem('cqArray')
					localStorage.removeItem('szArray')
					localStorage.removeItem('xmArray')
					localStorage.removeItem('tjArray')
					localStorage.setItem('nbArray', JSON.stringify(nbArray))
				}
			},

		}
	}
</script>

<style lang="scss" scoped>
	.login_box {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		background-image: url('../../assets/images/bg/login_view.jpg');
        background-repeat: no-repeat;
        background-size: 100% 100%;
		overflow: hidden;
	}
	.login_user_box {
		width: 300px;
		margin-right: 200px;
	}
	.login_title_box {
		width: 300px;
		margin-bottom: 40px;
	}
	.user_form /deep/ .el-input__prefix, .user_form /deep/ .el-input__suffix, .user_form /deep/ .el-input__suffix-inner {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.el-input__icon {
		width: 26px;
		height: 26px;
	}
	.user_form /deep/ .el-checkbox__label {
		color: #fff;
	}
	.user_form /deep/ .el-form-item__error {
		color: #ff0000;
	}
	.login_flex {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.head {
		cursor: pointer;
	}
	.verCodeImg {
		width: calc(40% - 20px);
		height: 40px;
		display: block;
	}

</style>



// WEBPACK FOOTER //
// login.vue?2f33574f